import React from "react";
import { EuiFlexGroup, EuiFlexItem } from '@elastic/eui';
import Flag from 'react-flagkit';

export const CodPaisCellRenderer = (params: any) => {
  if (params.node.rowPinned) {
    return null;
  }

  return (
    <EuiFlexGroup>
        <EuiFlexItem grow={false}>
        <Flag country={params.data.codPais} />
        </EuiFlexItem>
        <EuiFlexItem>
        <span>{params.data.codPais}</span>
        </EuiFlexItem>
    </EuiFlexGroup>
  );
};